/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Not_In_Crm_YetInputs */

const cs_ebr_not_in_crm_yet = /** @type {(inputs: Ebr_Not_In_Crm_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím není v CRM`)
};

const en_ebr_not_in_crm_yet = /** @type {(inputs: Ebr_Not_In_Crm_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not in CRM yet`)
};

/**
* | output |
* | --- |
* | "Not in CRM yet" |
*
* @param {Ebr_Not_In_Crm_YetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_not_in_crm_yet = /** @type {((inputs?: Ebr_Not_In_Crm_YetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Not_In_Crm_YetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_not_in_crm_yet(inputs)
	return cs_ebr_not_in_crm_yet(inputs)
});